import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates } from 'nuqs';

export function useExamEventActivityLogSearchParams() {
  return useQueryStates(
    {
      search: parseAsString.withDefault(''),
      page: parseAsPageNumber.withDefault(0),
      pageSize: parseAsInteger.withDefault(10),
      field: parseAsString.withDefault('actionTime'),
      sort: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
    },
    {
      urlKeys: {
        search: 'q',
      },
    },
  );
}
